import React from 'react';

import { css } from '@emotion/css';
import { Grid } from 'antd';

import { FlexSpace } from 'components/FlexSpace';
import { linkableText } from 'components/Links';

import { formatNumber, pluralize } from 'utils/formatting';

export function SearchFrameSelectionInfo({
  isSelectedPage,
  isSelectedAll,
  selectedRowsLength,
  totalHitsLength,
  onClear,
  onSelectAll,
}: {
  isSelectedPage?: boolean;
  isSelectedAll?: boolean;
  selectedRowsLength: number;
  totalHitsLength?: number;
  onClear: () => void;
  onSelectAll: () => void;
}) {
  const hasSelection = selectedRowsLength > 0 || isSelectedAll;
  const isMobileView = !(Grid.useBreakpoint()?.md ?? false);

  return hasSelection ? (
    <FlexSpace
      wrap
      className={css`
        ${isMobileView
          ? css`
              gap: 2px;
              margin-bottom: 2px;
              justify-content: flex-start;
              font-size: 12px;
              line-height: 14px;
            `
          : css`
              gap: 16px;
              margin-bottom: 16px;
              justify-content: center;
            `}
      `}
    >
      {
        // if only the first page is selected, then show a message asking if the user wants to select all
        isSelectedPage ? (
          <>
            <span
              className={css`
                ${isMobileView
                  ? css`
                      width: 100%;
                    `
                  : ''}
              `}
            >
              All <b>{selectedRowsLength}</b> items on this page are selected
            </span>
            {linkableText({
              onClick: onSelectAll,
              text: `Select all ${formatNumber(totalHitsLength)} items`,
            })}
          </>
        ) : hasSelection ? (
          // if not, then show the amount of items selected
          <span>
            {isSelectedAll ? (
              <>
                <b>{formatNumber(totalHitsLength)}</b> items
              </>
            ) : (
              <>
                <b>{selectedRowsLength}</b> {pluralize(selectedRowsLength, 'item')}
              </>
            )}
            {` selected `}
          </span>
        ) : null
      }
      {
        // If there is a selection, then show a button to allow for clearing
        hasSelection ? (
          <span
            className={css`
              ${isMobileView
                ? css`
                    margin-left: 16px;
                  `
                : ''}
            `}
          >
            {linkableText({
              onClick: onClear,
              text: 'Clear',
            })}
          </span>
        ) : null
      }
    </FlexSpace>
  ) : null;
}
